// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 12:30 AM
 */
import {connect} from "react-redux";
import {eBadgeUnlockAction, openUnlockEBadgeModalAction} from "../../actions/ebadge/creators/eBadgeUnlockActionCreator";
import type {StoreState} from "../../reducers/combinedReducers";
import type {EBadgeActionButtonDispatchProps, EBadgeActionButtonOwnProps, EBadgeActionButtonStateProps} from "../../components/ebadge/EBadgeActionButton";
import EBadgeActionButton from "../../components/ebadge/EBadgeActionButton";
import {extractCaller} from "../QueryPage";
import * as _ from 'lodash';
import type {Caller} from "../../components/QueryPage";
import config from "../../config/config";

function getIsLoadingStatus(state, registrationCode) {
    let eBadgeUnlockStatus = state.eBadgeAction.unlock[registrationCode];
    if (eBadgeUnlockStatus) {
        return eBadgeUnlockStatus.isLoading;
    } else {
        return false;
    }
}

const mapStateToProps = (state: StoreState, ownProps: EBadgeActionButtonOwnProps): EBadgeActionButtonStateProps => {
    const registrationCode = ownProps.registrationCode;
    const isLoading = getIsLoadingStatus(state, registrationCode);

    return {
        isLoading,
        caller: extractCaller(state),
        roleIds: state.loginUser.roleIds
    };
};

const mapDispatchToProps = (dispatch): EBadgeActionButtonDispatchProps => {
    return {
        onClick: (registrationCode: string, unlockCount: number, caller: Caller, roleIds: Array<string>) => {
            if (!_.includes(roleIds, config.superUserRole)) {

                dispatch(openUnlockEBadgeModalAction(registrationCode));
            } else {
                dispatch(eBadgeUnlockAction(registrationCode, caller));
            }
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(EBadgeActionButton);



// WEBPACK FOOTER //
// ./src/containers/ebadge/UnlockEBadgeButton.js